export type AppShellState = "loading" | "error" | "content";

export function resolveAppShellState(opts: {
  isAuthLoading: boolean;
  isAuthenticated: boolean;
  isConnectionLoading: boolean;
  hasAuthError: boolean;
  /** No point waiting for a live connection that cannot be made. */
  isOffline?: boolean;
  /** True once the shell has rendered the app at least once this session. */
  hasShownContent?: boolean;
}): AppShellState {
  if (opts.isAuthLoading) return "loading";

  const blockingConnect = opts.isAuthenticated
    && opts.isConnectionLoading
    && !opts.isOffline
    && !opts.hasShownContent;
  if (blockingConnect) return "loading";

  if (opts.hasAuthError) return "error";
  return "content";
}
